export interface TableColumnLookupDialog {
  getLookupResult(): any;
}
